
import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { Handshake } from "lucide-react";
import Autoplay from 'embla-carousel-autoplay';

const TrustedPartners = () => {
  const partners = [
    {
      name: "Travelers",
      logo: "/lovable-uploads/b923143c-996d-45a4-8122-af02b2911308.png"
    },
    {
      name: "Geico",
      logo: "/lovable-uploads/35f8abf1-0f87-4d6e-a0a6-1bac9471533d.png"
    },
    {
      name: "National General",
      logo: "/lovable-uploads/9b374fc2-0d96-45b4-a491-2a3ff3e10d6e.png"
    },
    {
      name: "Universal Properties",
      logo: "/lovable-uploads/21202e83-4e90-4766-b9fb-91221118ef30.png"
    },
    {
      name: "Openly",
      logo: "/lovable-uploads/0616c36e-1da4-4b7a-82a4-e39d4e4222f8.png"
    },
    {
      name: "Bristol West",
      logo: "/lovable-uploads/0548164e-9347-4a38-ac38-1491d3716088.png"
    },
    {
      name: "Foremost",
      logo: "/lovable-uploads/8a481b0b-7b51-407e-b61c-43de71de61a3.png"
    },
    {
      name: "Progressive",
      logo: "/lovable-uploads/c1df9b80-d125-4bb9-b042-1c905acad910.png"
    },
    {
      name: "Mercury",
      logo: "/lovable-uploads/c5b9a6e5-73da-4caf-b678-eb3873b0dca7.png"
    }
  ];

  const plugin = React.useMemo(
    () =>
      Autoplay({
        delay: 2000,
        stopOnInteraction: true,
      }),
    []
  );

  return (
    <section className="w-full py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <Badge variant="secondary" className="bg-[#F8F7FF] text-primary text-sm mb-4 flex items-center gap-1 mx-auto w-fit">
              <Handshake className="h-4 w-4" />
              Trusted Partners
            </Badge>
            <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-4">
              Insurance Carriers We Partner With
            </h2>
            <p className="text-neutral max-w-2xl mx-auto text-sm sm:text-base px-2 mb-6">
              We work with the most trusted names in insurance to provide you with comprehensive coverage options.
            </p>
          </div>

          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            plugins={[plugin]}
            className="w-full"
          >
            <CarouselContent>
              {partners.map((partner, index) => (
                <CarouselItem key={index} className="basis-1/2 md:basis-1/3 lg:basis-1/4">
                  <div className="p-2">
                    <div className="flex items-center justify-center h-24">
                      <img 
                        src={partner.logo}
                        alt={`${partner.name} logo`}
                        className="w-[125px] h-auto object-contain grayscale brightness-95 contrast-125"
                      />
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default TrustedPartners;

